module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_2_1.83479366.png";